<div class="preview-dialog" role="dialog" aria-modal="true" aria-labelledby="preview-title">
  <div class="preview-header">
    <h2 id="preview-title">Pré-visualização: {{ data.titulo || 'Arquivo' }}</h2>
    <button mat-icon-button (click)="cancelar()" matTooltip="Fechar" aria-label="Fechar pré-visualização">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-metadata">
    <span><strong>Nome:</strong> {{ fileName }}</span>
    <span><strong>Tamanho:</strong> {{ fileSizeMB }} MB</span>
    <span><strong>Tipo:</strong> {{ fileType }}</span>
    <span *ngIf="isProvaEscrita && isPdf && pageCount !== null" class="page-count-badge">
      <mat-icon class="page-count-icon">description</mat-icon>
      <strong>Páginas detectadas: {{ pageCount }}</strong>
    </span>
  </div>

  <div class="preview-content" *ngIf="!loading">
    <div *ngIf="isTooLarge" class="preview-message">
      <mat-icon class="warning-icon">warning</mat-icon>
      <p>Arquivo grande demais para pré-visualização ({{ fileSizeMB }} MB).</p>
      <p>Verifique os metadados acima e confirme o envio.</p>
    </div>

    <ngx-extended-pdf-viewer
      *ngIf="isPdf && pdfSrc"
      [src]="pdfSrc"
      [showToolbar]="true"
      [showDownloadButton]="false"
      [showPrintButton]="false"
      [showOpenFileButton]="false"
      [showPropertiesButton]="false"
      [showSecondaryToolbarButton]="false"
      [showSidebarButton]="false"
      [showRotateButton]="false"
      [showDrawEditor]="false"
      [showTextEditor]="false"
      [showStampEditor]="false"
      [showHighlightEditor]="false"
      [showBorders]="false"
      [textLayer]="true"
      height="100%"
      (pagesLoaded)="onPagesLoaded($event)"
    ></ngx-extended-pdf-viewer>

    <img *ngIf="isImage" [src]="mediaSrc" class="preview-media" [alt]="fileName" />

    <video *ngIf="isVideo" controls class="preview-media">
      <source [src]="mediaSrc" type="video/mp4" />
    </video>

    <div *ngIf="isZip" class="zip-contents">
      <p class="zip-summary">{{ zipEntries.length }} arquivo(s) no ZIP:</p>
      <table class="zip-table">
        <thead>
          <tr><th>Arquivo</th><th>Tamanho</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of zipEntries">
            <td>{{ entry.name }}</td>
            <td>{{ formatSize(entry.size) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="isGeneric" class="preview-message">
      <mat-icon class="info-icon">description</mat-icon>
      <p>Pré-visualização não disponível para este tipo de arquivo.</p>
      <p>Verifique os metadados acima e confirme o envio.</p>
    </div>
  </div>

  <div class="preview-content" *ngIf="loading">
    <div class="preview-message">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Carregando pré-visualização...</p>
    </div>
  </div>

  <mat-card *ngIf="isProvaEscrita && isPdf && !mostrarConfirmacaoReporte" class="card-info card-icon preview-ciencia-container">
    <mat-checkbox [(ngModel)]="confirmacaoChecked" (change)="onConfirmacaoChange()" color="primary"
      [disabled]="aplicandoMarcaDagua">
      Declaro ciência de que:
      <ul class="checkbox-topics">
        <li>O documento foi conferido em sua totalidade e contém todas as páginas de resposta do candidato (<span class="page-count-highlight">{{ pageCount }} página{{ pageCount === 1 ? '' : 's' }}</span>).</li>
        <li>Não consta página de rosto ou qualquer identificação do candidato, em conformidade com o
          <span class="edital-link"
            matTooltip='"É proibido qualquer tipo de identificação no caderno de respostas, como nome, assinatura, número de documento, recados, símbolos ou qualquer outra marca que possa identificar o candidato fora dos campos especificamente indicados para esse fim."'
            matTooltipClass="edital-tooltip"
            matTooltipPosition="above">sub item 9.1.7.1</span>
          do edital.</li>
      </ul>
    </mat-checkbox>
  </mat-card>

  <div *ngIf="mostrarConfirmacaoReporte" @slideInOut class="inline-confirm-banner">
    <mat-icon class="inline-confirm-icon">warning</mat-icon>
    <p>
      O reporte será enviado ao presidente da comissão julgadora para decisão.
    </p>
    <mat-form-field appearance="outline" class="reporte-justificativa-field">
      <mat-label>Motivo da suspeita</mat-label>
      <textarea matInput [(ngModel)]="justificativaReporte" rows="2"
        placeholder="Ex: Nome visível na página 2, assinatura na margem..."></textarea>
    </mat-form-field>
    <div class="inline-confirm-actions">
      <button mat-stroked-button (click)="cancelarReporte()">Voltar</button>
      <button mat-flat-button color="warn" (click)="confirmarReporte()" [disabled]="aplicandoMarcaDagua || !justificativaReporte.trim()">
        <span *ngIf="!aplicandoMarcaDagua">Confirmar e enviar</span>
        <mat-spinner *ngIf="aplicandoMarcaDagua" diameter="20"></mat-spinner>
      </button>
    </div>
  </div>

  <div class="preview-actions" *ngIf="!mostrarConfirmacaoReporte">
    <button mat-stroked-button color="warn"
      *ngIf="isProvaEscrita && isPdf"
      (click)="reportarIdentificacao()"
      [disabled]="confirmacaoChecked || pageCount === null"
      aria-label="Reportar identificação do candidato">
      <mat-icon>report_problem</mat-icon>
      Reportar identificação do candidato
    </button>
    <span class="actions-spacer"></span>
    <button mat-stroked-button (click)="cancelar()" aria-label="Cancelar envio do arquivo">
      Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="confirmar()" [disabled]="isConfirmDisabled" aria-label="Confirmar envio do arquivo">
      Confirmar Envio
    </button>
  </div>
</div>
